import axios from 'axios'
import { useQuery } from '@tanstack/react-query'
import { MutateRequest } from '../request-type'
import TransitApiConfig from '../apiConfig'
import {
  CompanyTransitOperationInfoResponse,
  CreateTransitOperationInfoRequest,
  NotesTransitOperationInfoRequest,
  TransitOperationInfoResponse,
} from '../../../../../api/models'

const {
  baseUrl,
  queryKeys: {
    getTransitOperationInfoByTransitOperationId,
  },
} = TransitApiConfig.paths.transitOperationInfo

export async function postTransitOperationInfo(data: CreateTransitOperationInfoRequest) {
  return (await axios.post<TransitOperationInfoResponse>(baseUrl, data)).data
}

export async function patchCompanyTransitOperationInfoNotesOrFeedback({
  id,
  data,
}: MutateRequest<NotesTransitOperationInfoRequest>) {
  return (await axios.patch<CompanyTransitOperationInfoResponse>(`${baseUrl}/company/${id}`, data)).data
}

export async function patchTransitOperationInfoNotesOrFeedback({
  id,
  data,
}: MutateRequest<NotesTransitOperationInfoRequest>) {
  return (await axios.patch<TransitOperationInfoResponse>(`${baseUrl}/${id}`, data)).data
}

function useTransitOperationInfoApi(transitOperationId: number | null, isAdmin: boolean) {
  const getTransitOperationInfo = useQuery({
    enabled: !!transitOperationId && isAdmin,
    queryFn: async ({ signal }) => (await axios
      .get<TransitOperationInfoResponse>(`${baseUrl}/${transitOperationId}`, { signal })).data,
    queryKey: getTransitOperationInfoByTransitOperationId(transitOperationId),
    staleTime: Infinity, // never stale
  })

  return {
    getTransitOperationInfo,
  }
}

export default useTransitOperationInfoApi
